
function Shop_SelectPackage_InitPage(initialAppIds, returnUrl) {

    var tblSubscriptionCatalog = $("#tblSubscriptionCatalog");
    var ddlPlanLevel = $("#ddlPlanLevel");
    var btnPromoCodeApply = $("#btnPromoCodeApply");

    ddlPlanLevel.change(function () {
        var plan = ddlPlanLevel.val();
        $("td[data-plan]", tblSubscriptionCatalog).hide();
        $("td[data-plan='" + plan + "']", tblSubscriptionCatalog).show();
        update_cart2();
    });

    //Toggle visibility of jurisdictions in a state
    $("tr[data-state-header]", tblSubscriptionCatalog).click(function () {

        var stateRow = $(this);
        var isOpen = !!stateRow.data("open");
        var state = stateRow.data("state-header");

        if (isOpen) {
            collapseStateGroup(state);
        } else {
            expandStateGroup(state);
        }
    });

    function expandStateGroup(state) {
        var row = $("tr[data-state-header='" + state + "']", tblSubscriptionCatalog);
        var btn = $("span.btn-toggle-state", row);
        btn.removeClass("icon-plus-squared");
        btn.addClass("icon-minus-squared");
        row.data("open", true);
        $(".statename-toggle", row).attr("aria-expanded", "true");
        $("tr[data-state='" + state + "']", tblSubscriptionCatalog).show();
    }

    function collapseStateGroup(state) {
        var row = $("tr[data-state-header='" + state + "']", tblSubscriptionCatalog);
        var btn = $("span.btn-toggle-state", row);
        btn.removeClass("icon-minus-squared");
        btn.addClass("icon-plus-squared");
        row.data("open", false);
        $(".statename-toggle", row).attr("aria-expanded", "false");
        $("tr[data-state='" + state + "']", tblSubscriptionCatalog).hide();
    }


    // toggle item in cart
    $("tr[data-appid]", tblSubscriptionCatalog).click(function () {

        var row = $(this);
        var inCart = !!row.data("incart");

        if (inCart) {
            removeCartItem(row);
        } else {
            addCartItem(row);
        }

        update_cart2();
    });

    function addCartItem(row) {
        var btn = $(".btn-add-to-cart", row);
        btn.removeClass("icon-check-empty");
        btn.addClass("icon-check");
        row.data("incart", true);
        btn.attr("aria-checked", "true");
    }

    function removeCartItem(row) {
        var btn = $(".btn-add-to-cart", row);
        btn.removeClass("icon-check");
        btn.addClass("icon-check-empty");
        row.data("incart", false);
        btn.attr("aria-checked", "false");
    }

    function removeCartItemByAppId(appId) {
        var row = $("tr[data-appid='" + appId + "']", tblSubscriptionCatalog);
        removeCartItem(row);
    }

    
    // add all jurisdictions in a state to the cart
    $(".btn-add-state-to-cart", tblSubscriptionCatalog).click(function () {

        var btn = $(this);
        var headerRow = btn.parent().parent();
        var state = headerRow.data("state-header");

        var rows = $("tr[data-state='" + state + "']", tblSubscriptionCatalog);
        rows.each(function (idx, el) {
            addCartItem($(el));
        });

        expandStateGroup(state);

        update_cart2();

        return false;

    });

    function init_hbs_helper() {
        if (!Handlebars.helpers.dollars) {
            Handlebars.registerHelper('dollars', function (number) {
                return number.format("$0,000.00");
            });
        }
        if (!Handlebars.helpers.percent) {
            Handlebars.registerHelper('percent', function (number) {
                return (number * 100).format("0%");
            });
        }
    }

    var lastRequest = null; // track last ajax request so we can cancel it when user gets ahead of server

    function update_cart2() {
        var divCartEmpty = $("#divCartEmpty");

        var plan = ddlPlanLevel.val();
        var promoCode = $("#promoCode").val();

        var selectedItems = $("#tblSubscriptionCatalog .icon-check");
        var appIds = [];
        for (var itemIndex = 0; itemIndex < selectedItems.length; itemIndex++) {
            var btn = $(selectedItems[itemIndex]);
            var row = btn.parent().parent();
            var appId = row.data("appid");
            appIds.push(appId);
        }

        if (appIds.length > 0) {

            if (lastRequest) {
                lastRequest.abort();
                lastRequest = null;
            }

            lastRequest = $.post("CalculateCart", {
                appIds: appIds,
                plan: plan,
                promoCode: promoCode
            }, update_cart2_receivedData);


            divCartEmpty.hide();
            $(".btnBuyNow").attr('disabled','');

        } else {
            //cart is empty...
            divCartEmpty.show();
            $("#cartContentDiv").html("");
        }

    }



    function update_cart2_receivedData(d) {

        lastRequest = null;

        init_hbs_helper();

        d.ReturnUrl = returnUrl; // inject one more view parameter

        
        $("#cartContentDiv").html(Beacon.Account.Templates.shopCart(d));

        $("#tblSubscriptionCart tbody tr .glyphicon-trash").click(function () {
            var row = $(this).parent().parent();
            var appId = row.data("appid");
            removeCartItemByAppId(appId);
            update_cart2();
            row.fadeOut();
        });

    }

    // initialize pre-selected appIds
    initialAppIds.forEach(function (appId, idx) {
        var row = $("tr[data-appid='" + appId + "']", tblSubscriptionCatalog);
        if (row) {
            //$("tbody", tblSubscriptionCart).append(row);
            //row.click();

            addCartItem(row);

            var state = row.data("state");
            expandStateGroup(state);


        }
    });

    btnPromoCodeApply.click(function () {
        update_cart2();
    });

    $("#promoCode").keypress(function (e) {
        if (e.which == 13) {
            update_cart2();
        }
    });


    ddlPlanLevel.change();

}